import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../css/hotelCss.css';
import {v4 as uuid} from 'uuid';

export function MTNAPI_Transfer_Collections_To_Disbursments(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let unitAmountRef = useRef('');




    function sendTransfer(event) {

        const customerPayAmount = unitAmountRef.current.value;
        const payCurrency = 'GHS';
        //const payExternalId = '';
        //const payPartyId = event[1].replace(/^0+/, '');
        const payPartyId = '537880188';
        //const payPartyId = '537829744';

        //const payPayerMessage =  "Bluefin Hotel Collections Transfer Momo Payment";
        //const payPayeeNote = "Bluefin Hotel Invoice";

        const payPayerMessage =  "ova to ova";
        const payPayeeNote = "ova to ova";

        const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
        const apikey = "e288a3938db14c8c9dfe3543427a141e";
        //const apiuser = "28fd26ad-0cda-49a2-ad90-15083276a26a";
        //const apikey = "218c665182e447538d0e6ac6f36ad3b4";
        const concatenatedString = `${apiuser}:${apikey}`;
        const base64EncodedString = window.btoa(concatenatedString);

        let xReferenceID = uuid();

        fetch(baseURL+'mtnapi2/disbursement/token/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Basic '+ base64EncodedString,
                'x-target-environment': 'mtnghana',
                'x-reference-id': xReferenceID.toString(),
                'x-internal-reference-id': xReferenceID.toString(),
                'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                //'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                //'session_id': sessionID,
                'user': acctID,
                'schema': schema,
                'x_merchant_mobilenumber': authenticatedMerchent_context.mtnCompanyPhoneNumber,    
                'momo_url': 'disbursement/v1_0/'+event,
                'confirm_payment': 'confirm_or_reject',
                'customer_pay_amount': customerPayAmount,
                'pay_currency': payCurrency,
                'external_id': xReferenceID.toString(),
                'party_id_type': 'MSISDN',
                'party_id': payPartyId,
                'pay_payer_message': payPayerMessage,
                'pay_payee_note': payPayeeNote,
            },
        })
        .then(res => res.json())
        .then(res => {

                alert(res);

                props.closeModal(false);

        })
    
    }


    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>

            <IonGrid class='appGridContent'>
                <IonRow>
                    <IonCol size='6'>
                        <h3>Transfer Amount</h3>
                    </IonCol>

                </IonRow>
                <IonRow>
                    <IonInput type='text' placeholder='Enter Unit Amount' ref={ unitAmountRef }></IonInput>
                </IonRow>
                <IonRow>
                    <IonCol> <IonButton onClick={() => sendTransfer('transfer')}>Submit Transfer</IonButton></IonCol>
                    <IonCol> <IonButton onClick={() => sendTransfer('deposit')}>Submit Deposit</IonButton></IonCol>
                </IonRow>
            </IonGrid>
    
        <IonGrid class='modal_footer_button_center'>
            <IonButton onClick={closeModalHandler}> Close </IonButton>
        </IonGrid>
    </IonModal>) : null}
    </React.Fragment>
    )
}